import React, { SetStateAction, useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../../styles/CustomModal.css";

import { useLocation } from "react-router-dom";
import {
  optionGroupType,
  optionType,
} from "../../../controller/StoreController";
import { getOptionName, getOptionTypeName } from "../../../utils/util";
import { useRecoilState } from "recoil";
import { langState, langText } from "../../../recoil/lang";

import { useToast } from "../../../controller/ToastController";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  option: optionGroupType[];
  setSelectedProduct: any;
  RenderProductDetail: any;
  selectedOption: number[][];
  setSelectedOption: React.Dispatch<SetStateAction<number[][]>>;
  addCart: () => any;
  resetTimer: any;
};

// 옵션 선택 화면
const RenderOptionList = (oProps: any) => {
  const showToast = useToast();

  const { selectedOption, setSelectedOption, lang } = oProps;
  const option: optionGroupType[] = oProps.option;

  // 필수 1개
  const handleRadioChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];
    temp[index] = [optionIndex];
    setSelectedOption(temp);
  };
  // 필수 여러개 or 최대선택
  const handleCheckboxChange = (
    item: optionType,
    index: number,
    optionIndex: number
  ) => {
    let temp = [...selectedOption];

    const indexToRemove = temp[index].indexOf(optionIndex);
    if (indexToRemove !== -1) {
      temp[index].splice(indexToRemove, 1);
    } else {
      if (option[index].option_input_max <= temp[index].length) {
        if (option[index].option_input_min === 0) {
          showToast(
            langText.optionModal_title_Maximum[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        } else {
          showToast(
            langText.optionModal_title_Required[lang] +
              option[index].option_input_max +
              langText.optionModal_detail_choice[lang],
            "error"
          );
        }
        return;
      } else {
        temp[index].push(optionIndex);
      }
    }

    setSelectedOption(temp);
  };
  return (
    <div className="optionListWrap">
      {option?.map((optionGroup: optionGroupType, index: number) => {
        return (
          optionGroup.option_list.length > 0 && (
            <div className="oprionList">
              <div className="optionName">
                <h3>{getOptionTypeName(optionGroup, lang)}</h3>

                {/* 필수1개 - radio */}
                {((optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max === 0) ||
                  (optionGroup.option_input_min === 1 &&
                    optionGroup.option_input_max === 1)) && (
                  <span className="require">
                    ({langText.optionModal_title_Required[lang]}1
                    {langText.title_detail_count[lang]})
                  </span>
                )}
                {/* 필수1개 이상 - checkbox */}
                {optionGroup.option_input_min !== 0 &&
                  optionGroup.option_input_max > 1 && (
                    <>
                      <span className="require">
                        ({langText.optionModal_title_Required[lang]}
                        {optionGroup.option_input_min}
                        {langText.title_detail_count[lang]})
                      </span>
                      {optionGroup.option_input_min !==
                        optionGroup.option_input_max && (
                        <span className="noneRequire">
                          ({langText.optionModal_title_Maximum[lang]}
                          {optionGroup.option_input_max}
                          {langText.title_detail_count[lang]})
                        </span>
                      )}
                    </>
                  )}
                {/* 최대 선택 이상 - checkbox */}
                {optionGroup.option_input_min === 0 &&
                  optionGroup.option_input_max > 0 && (
                    <span className="noneRequire">
                      ({langText.optionModal_title_Maximum[lang]}{" "}
                      {optionGroup.option_input_max}
                      {langText.title_detail_count[lang]})
                    </span>
                  )}
              </div>
              <div className="optionButtonWrap">
                {optionGroup?.option_list.map(
                  (option: optionType, optionIndex: number) => {
                    const optionId = `option_${index}_${optionIndex}`;
                    const requireType =
                      (optionGroup.option_input_min === 0 &&
                        optionGroup.option_input_max === 0) ||
                      (optionGroup.option_input_min === 1 &&
                        optionGroup.option_input_max === 1);
                    const inputName = `${requireType ? "require" : ""}${index}`;

                    const isDisabled = option.is_soldout === 1;
                    const isSelected =
                      selectedOption[index].includes(optionIndex);

                    return requireType ? (
                      // 필수 1개
                      <div
                        key={optionIndex}
                        className={`optionButton ${
                          isSelected ? "active" : ""
                        } ${isDisabled ? "disabled" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="radio"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={() => {
                              if (!isDisabled)
                                handleRadioChange(option, index, optionIndex);
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    ) : (
                      // 필수 여러개 또는 최대선택
                      <div
                        key={optionIndex}
                        className={`optionButton ${
                          isSelected ? "active" : ""
                        } ${isDisabled ? "disabled" : ""}`}
                      >
                        <label htmlFor={optionId}>
                          <input
                            type="checkbox"
                            id={optionId}
                            name={inputName}
                            value={option.option_id}
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={() => {
                              if (!isDisabled)
                                handleCheckboxChange(
                                  option,
                                  index,
                                  optionIndex
                                );
                            }}
                          />
                          <h3>{getOptionName(option, lang)}</h3>
                          <h3 className="optionPrice">
                            {option.option_price_nrm}원
                          </h3>
                        </label>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          )
        );
      })}
    </div>
  );
};

const OptionModal = ({
  isVisible,
  setVisible,
  option,
  setSelectedProduct,
  RenderProductDetail,
  selectedOption,
  setSelectedOption,
  addCart,
  resetTimer,
}: Props) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  // 옵션 초기화
  const optionReset = () => {
    setSelectedOption(
      option?.map((prdOption) => {
        if (
          (prdOption.option_input_max === 0 &&
            prdOption.option_input_min === 0) ||
          prdOption.option_input_min === 1
        ) {
          if (
            prdOption.option_list.filter((o) => o.is_soldout === 0).length === 0
          ) {
            return [];
          }

          const availableIndex = prdOption.option_list.findIndex(
            (opt) => opt.is_soldout !== 1
          );
          return availableIndex > 0 ? [availableIndex] : [0];
        }
        return [];
      })
    );
  };
  // 초기화 버튼
  const onResetOption = () => {
    optionReset();
    setVisible(false);
  };
  // 옵션 닫기 버튼
  const onCloseModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!isVisible) {
      setSelectedOption([]);
      setSelectedProduct([]);
    }
  }, [isVisible]);

  useEffect(() => {
    optionReset();
  }, [isVisible, option]);

  if (!isVisible || !option) {
    return null;
  }

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "optionCustomModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div
          className="optionWrap"
          onTouchStart={resetTimer}
          onScrollCapture={resetTimer}
        >
          <div className="optionTitle">
            <h2>{langText.optionModal_title_optionSelect[lang]}</h2>
            <button onClick={onCloseModal}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/optionClose.svg`}
                alt="옵션닫기"
              />
            </button>
          </div>
          <RenderProductDetail />
          <RenderOptionList
            option={option}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            setVisible={setVisible}
            lang={lang}
          />
          <div className="modalFooter">
            <button className="resetOptonButton" onClick={onResetOption}>
              <h2>{langText.optionModal_button_ClearAll[lang]}</h2>
            </button>
            <button onClick={addCart}>
              <h2>{langText.optionModal_button_AddToCart[lang]}</h2>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OptionModal;

const Style = styled.div`
  .optionWrap {
    display: flex;
    flex-direction: column;
    height: 85vh;
  }

  .optionTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 21px 20px 45px;

    h2 {
      font-size: 24px;
      font-weight: 300;
      color: #fff;
    }
  }

  /* 옵션 상세 설명 */
  .productDetailWrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 45px 24px 45px;
    border-bottom: 1px solid #555;

    .detailImgWrap {
      max-width: 200px;
      img {
        aspect-ratio: 5/4;
      }
    }
    .detailTextWrap {
      flex: 1;
      margin-left: 20px;
      height: 100%;

      p {
        margin: 16px 0 0 0;
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
        line-height: 24px;
        word-break: keep-all;
        overflow-y: auto;
        max-height: 80px;
      }
    }
    .detailImg {
      width: 100%;
      border-radius: 10px;
    }
  }
  .detailTextTitle {
    text-align: left;
    width: 100%;

    .detailName {
      max-height: 130px;
      margin-bottom: 6px;
      overflow-y: scroll;
    }
  }

  /* 옵션리스트 */
  .optionListWrap {
    flex: 1;
    padding: 20px 45px;
    overflow-y: auto;
  }
  .optionName {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    h3 {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    span {
      margin-left: 4px;
      font-size: 16px;
      font-weight: 400;
    }
    .require {
      color: #d14848;
    }
    .noneRequire {
      color: #327ad0;
    }
  }
  .optionButtonWrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .optionButton {
    flex: 0 0 24%;
    margin-bottom: 0.5%;
    min-width: 129px;
    margin: 0.5%;
    background: #343434;
    border: 2px solid #e5e5e5;
    padding: 18px;
    border-radius: 10px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #e5e5e5;
    }
    .optionPrice {
      margin-top: 16px;
    }
    label {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }
  }
  .disabled {
    background: #656565;
    border-color: #656565;

    h3 {
      color: #979797;
    }
  }
  label input {
    display: none;
  }
  .optionButton.active {
    background: #40977f;
    border: 2px solid #fff;

    h3 {
      color: #fff;
    }
  }
  .modalFooter {
    width: 100%;
    padding: 24px 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #555555;
    background-color: #343434;

    button {
      width: 50%;
      margin: 0 5px;
      padding: 14px 0;
      border-radius: 10px;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      outline: none;

      h2 {
        color: #fff;
        font-weight: 600;
        font-size: 22px;
      }
    }
    .resetOptonButton {
      background: #343434;
      border: 1px solid #777777;
    }
  }
`;
